import classNames from 'classnames';
import React from 'react';

import css from './IconShellfish.module.css';

const IconShellfish = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85 85"
    >
      <path
        d="M80.113 39.677c-6.371-7.835-28.326-29.266-59.928-.286v-.01s-3.976-11.295-15.3-10.492c0 0 6.041 7.396 6.041 13.347v.631c0 5.951-6.041 13.346-6.041 13.346 11.325.805 15.275-10.412 15.275-10.412 30.863 28.35 52.508 8.555 59.461.299l-4.002-2.391 4.494-4.032z"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
      />
      <path
        d="M63.016 32.125c-2.785 4.494-5.422 13.148 2.947 24.697"
        fill="none"
        stroke="#011602"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
      />
      <path
        d="M60.951 25.815s-.965-8.02-4.824-10.368c0 0-18.948-1.153-24.35 14.931"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
      />
      <path
        d="M39.167 20.565s1.66 3.809 1.801 5.713M45.066 17.398s1.682 4.646 2.358 7.452M50.779 15.907s2.303 5.329 3.229 8.758"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
      />
      <path
        d="M43.527 63.533c-.414 2.139-1.359 4.682-3.511 6.039 0 0 9.536-.291 15.95-9.049"
        fill="none"
        stroke="#011602"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
      />
      <g
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
      >
        <path d="M53.971 32.186s-4.004 2.453-1.002 7.33M53.971 53.252s-4.004-2.455-1.002-7.332" />
      </g>
      <path
        d="M45.92 46.418s-3.648-2.959-.031-7.4"
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
      />
      <circle cx="69.148" cy="38.477" fill="#011602" r="2.023" />
      <path
        fill="none"
        stroke="#011602"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.5"
        d="M20.186 39.381v2.587"
      />
    </svg>
  );
};

export default IconShellfish;
